import axios from 'axios';
import { SERVICE } from '../constants';
import { Platform, Linking } from 'react-native';

/**
 * Function returns true if input numeric and finite;
 *  @param n - input
 */
export function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function openURL(url) {
    if (Platform.OS === 'web') {
        window.open(url, '_blank');
    } else {
        Linking.canOpenURL(url)
            .then((supported) => {
                if (supported) {
                    return Linking.openURL(url);
                }
            })
            .catch((err) => console.error('An error occurred', err));
    }
}

export const serialize = (obj, prefix) => {
    let str = [];
    let p;

    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            let k = prefix ? prefix : p;
            let v = obj[p]; // prefix + "[" + p + "]"
            str.push(v !== null && typeof v === "object" ?
                serialize(v, k) :
                encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
    }

    if (str.length) {
        return '?' + str.join("&").replace('?', '');
    }

    return '';
};
const FETCH = ({ data, success, fail, always, method, path, headers }) => {
    let authkey = '';
    let data2 = {
        ...data,
        service: SERVICE
    };

    if (authkey) {
        // data2.authkey = authkey;
    }
    axios({
        method,
        // withCredentials: true,
        url: CREATE_API_URL({ path }),
        data: data2,
        headers: headers || { 'Content-Type': 'application/json;charset=UTF-8' },
    })
        .then(response => {
            // if (response.status !== 200) {
            //     throw Error;
            // }

            let alerts = [];
            if (response.data.alert || response.data.alerts || response.data.Message) {

                if (response.data.alert) {
                    alerts = [response.data.alert];
                }

                if (response.data.Message) {
                    alerts = [response.data.Message];
                }

                if (response.data.alerts) {
                    alerts = [...response.data.alerts];
                }

                alerts = alerts.length ? alerts : [{ message: response.data.toString() }];

                alerts = alerts.filter(alert => alert.message || alert.title);
            }

            response.data.alerts = alerts;

            let isError = false;

            response.data.alerts.forEach(alert => {

                if (alert.level === 'error') {
                    isError = true;
                }
            });

            if (isError) {
                fail && fail(response.data.alerts);
                // return;
            } else {
                success && success(response.data);
            }

            always && always(response.data);

        })
        .catch(error => {

            console.log("axios error");
            console.log(error);
            // if (error.response && error.response.hasOwnProperty('status')) {
            //     if (error.response.status === 401) {
            //         if (isChild) {
            //             redirectToLogin(window.parent);
            //         } else {
            //             redirectToLogin();
            //         }
            //     }
            // }

            // if (error.response.data.alert || error.response.data.alerts || error.response.data.Message) {

            //     if (error.response.data.alert) {
            //         error.response.data.alerts = [error.response.data.alert];
            //     }

            //     if (error.response.data.Message) {
            //         error.response.data.alerts = [{ message: error.response.data.Message }];
            //     }
            // }

            // let alerts = (error.response && error.response.data.alerts) || [{ message: error.toString() }];

            // fail && fail(alerts);
            // always && always(alerts);
        });
};

export const CREATE_API_URL = ({ path }) => {
    if (path.includes('://')) {
        return path;
    }

    return path;
};

export const GET = params => FETCH({ ...params, method: 'get', path: `${params.path}${serialize(params.data)}` });
export const DELETE = params => FETCH({ ...params, method: 'delete' });
export const POST = params => FETCH({ ...params, method: 'post' });
export const PUT = params => FETCH({ ...params, method: 'put' });

export const FILE = ({ data, success, fail, always, path }) => {
    var data2 = new FormData();

    Object.keys(data).forEach(key => {
        data2.append(key, data[key]);
    });

    axios({
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: false,
        // withCredentials: !(process.env.NODE_ENV === 'production'),
        url: CREATE_API_URL({ path }),
        data: data2
    })
        .then(response => {
            if (response.status !== 200 || response.data.alerts) {
                throw Error;
            }
            success && success(response.data);
            always && always();
        })
        .catch(error => {
            let alerts = (error.response && error.response.data.alerts) || [{ message: error.toString() }];

            fail && fail(alerts);
            always && always();
        });
};
